import React from 'react';
import PropTypes from 'prop-types';
import payoutStatuses from 'enums/payoutStatuses';
import { getShortDateFormat } from 'helpers/DateHelper';

import Button from '@material-ui/core/Button';
import Form from 'form/Form';
import { TextField, Checkboxes } from 'mui-rff';
import MenuItem from '@material-ui/core/MenuItem';
import NullableDatePicker from 'form/NullableDatePicker';
import AdminFormWrapper from '../../presentational/AdminFormWrapper';
import AdminFormButtons from '../../presentational/AdminFormButtons';
import AdminFormFields from '../../presentational/AdminFormFields';

const SearchPayoutsForm = ({ searchParameters, onSubmit, isSubmitting = false }) => {
    const statuses = [{
        key: 'all',
        title: '[all]'
    }].concat(Object.values(payoutStatuses).map(o => ({ key: o.key, title: o.key })));

    return (
        <AdminFormWrapper isSubmitting={isSubmitting}>
            <Form
                initialValues={searchParameters}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <AdminFormFields>
                            <TextField
                                select
                                name="status"
                                label="Status"
                                variant="outlined"
                            >
                                {
                                    statuses.map(item =>
                                        <MenuItem key={item.key} value={item.key}>{item.title}</MenuItem>
                                    )
                                }
                            </TextField>

                            <TextField
                                name="ownerName"
                                label="Owner name"
                                variant="outlined"
                            />

                            <Checkboxes
                                name="storage365PayoutsOnly"
                                data={{
                                    label: 'Commission fee payouts only',
                                    value: true
                                }}
                            />

                            <NullableDatePicker
                                name="createdDateFrom"
                                label="Created from"
                                formatFunc={getShortDateFormat}
                                inputVariant="outlined"
                                nullString={''}
                                nullButtonLabel="Clear"
                            />

                            <NullableDatePicker
                                name="createdDateTo"
                                label="Created to"
                                formatFunc={getShortDateFormat}
                                inputVariant="outlined"
                                nullString={''}
                                nullButtonLabel="Clear"
                            />
                        </AdminFormFields>

                        <AdminFormButtons>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Search
                            </Button>
                        </AdminFormButtons>
                    </form>
                )}
            </Form>
        </AdminFormWrapper>
    );
};

SearchPayoutsForm.propTypes = {
    searchParameters: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};

export default SearchPayoutsForm;
